import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-veri-sorumlusu-basvuru-formu",
  templateUrl: "./veri-sorumlusu-basvuru-formu.component.html",
  styleUrls: ["./veri-sorumlusu-basvuru-formu.component.scss"],
})
export class VeriSorumlusuBasvuruFormuComponent implements OnInit {
  hostName = environment.hostName();

  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    scrollToTop();

    this.metaService.set({
      title: "Veri Sorumlusu Başvuru Formu - Bilgesin",
      description: "Veri Sorumlusu Başvuru Formu",
    });
  }
}
